<template>
  <v-container>

    <v-row class="justify-center">
      <v-col cols="12" md="6" class="text-center">
        <h2>About Us</h2>
        <p class="mx-auto">
          TeamHive.live is the new home for live-streaming events from local high schools.
          We have developed a brand new streaming platform to connect your local high school to the community.
        </p>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col cols="12" md="6" class="text-center">
        <h2>Contact Us</h2>
        <p>
          If you would like your school to join TeamHive’s free video streaming platform, Contact Us at:<br>
          <a href="mailto:info@teamhive.live">info@teamhive.live</a>
        </p>
      </v-col>
    </v-row>

    <v-divider style="width: 75%;" class="mx-auto my-7"></v-divider>

  </v-container>
</template>
<script>
export default {
};
</script>
